import {Component, Vue} from "vue-property-decorator";

@Component
export default class FlashLinks extends Vue {
  public scrollTop = window.pageYOffset
  public timer = 0
  public isFixed = false

  mounted() {
    window.addEventListener("scroll", this.scrollToTop); //watch scroll
  }

  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop); //remove watch scroll
  }

  public scrollToTop() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    this.scrollTop = scrollTop;
    if (this.scrollTop > 670) {
      this.isFixed = true;
    } else {
      this.isFixed = false;
    }
  }

  public backTop() {
    const timer = setInterval(() => {
      const ispeed = Math.floor(-this.scrollTop / 5)
      document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop + ispeed
      if (this.scrollTop === 0) {
        clearInterval(timer)
      }
    }, 16);
    console.log(0);
  }

}
